import React, { useState } from "react";
import { PrimaryButton } from "../Map/map.style";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import GuestCheckoutModal from "../cards/GuestCheckoutModal";

const CartActions = (props) => {
  const { setSideDrawerOpen, cartList } = props;
  const token = localStorage.getItem("token");
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const router = useRouter();

  const handleRoute = () => {
    router.push("/checkout?page=cart", undefined, { shallow: true });
  }
  const handleCheckout = () => {
    if (cartList?.length > 0 && !token) {
      // Always show guest checkout modal for non-authenticated users with items in cart
      setOpen(true);
    } else if (cartList?.length > 0 && token) {
      router.push("/checkout?page=cart", undefined, { shallow: true });
      setSideDrawerOpen(false);
    } else {
      if (cartList?.length === 0) {
        setSideDrawerOpen(false);
        router.push("/home", undefined, { shallow: true });
      }
    }
  };
  // const handleCheckout = () => {
  //   if (cartList?.length > 0) {
  //     router.push("/checkout?page=cart", undefined, { shallow: true });
  //     setSideDrawerOpen(false);
  //   } else {
  //     if (router.pathname === "/home") {
  //       setSideDrawerOpen(false);
  //     } else {
  //       router.push("/home", undefined, { shallow: true });
  //     }
  //   }
  // };

  return (
    <Stack
      direction="row"
      width="100%"
      spacing={1}
      paddingX="1.25rem"
      pb="1rem"
    >
      <PrimaryButton
        onClick={handleCheckout}
        variant="contained"
        size="large"
        fullWidth
        sx={{ borderRadius: "7px" }}
      >
        {cartList?.length > 0
          ? t("Proceed To Checkout")
          : t("Continue Shopping")}
      </PrimaryButton>
      {open &&
        <GuestCheckoutModal
          open={open}
          setOpen={setOpen}
          setSideDrawerOpen={setSideDrawerOpen}
          handleRoute={handleRoute}
        />
      }
    </Stack>
  );
};

CartActions.propTypes = {};

export default CartActions;
